import NotificationRecipientForm from 'pages/shared/NotificationRecipientForm'

import Api from 'services/api'

const EditNotificationRecipient = () => (
  <NotificationRecipientForm
    title="Edit Notification Recipient"
    onValidatedSave={Api.NotificationRecipients.update}
    readOnlyMessage="Read-only view: can't edit Notification Recipient"
    displayDeleteButton
    displayMutedNotifications
    customerCardCollapsed
  />
)

export default EditNotificationRecipient
